import validator from "validator";
import message from "../../../messages/role";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validatePersianName = (persianName) => {
  if (validator.isEmpty(persianName)) {
    return message.PERSIAN_NAME_DOSE_NOT_EXIST;
  }

  if (!persianName.trim().length) {
    return message.PERSIAN_NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validatePermissions = (permissions) => {
  if (permissions.length == 0) {
    return message.PERMISSIONS_DOSE_NOT_EXIST;
  }

  return true;
};

const validateFormPermisson = (info) => {
  const resValidateName = validateName(info.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  const resValidatePersianName = validatePersianName(info.persian_name);
  if (resValidatePersianName != true) {
    return resValidatePersianName;
  }

  const resValidatePermissions = validatePermissions(info.permissions);
  if (resValidatePermissions != true) {
    return resValidatePermissions;
  }

  return true;
};

export default validateFormPermisson;
